import {Modal} from "react-bootstrap";
import React, {useState} from "react";
import {Toast} from "../../../utils/Toast";
import {useTranslation} from "react-i18next";
import Papa from "papaparse";
import {FullPageLoader} from "../../../utils/FullPageLoader";
import {CSVLink} from "react-csv";
import {userFieldService} from "../../../services/user-field.service";

const csvData = [
    {"userName": "member1", "fieldName": "Field A", "value": "123"},
    {"userName": "member1", "fieldName": "Field B", "value": "abc"},
    {"userName": "member2", "fieldName": "Field A", "value": "456"},
    {"userName": "member2", "fieldName": "Field C", "value": "xyz",}
];

export const ImportUserFieldModal: React.FC<any> = (props) => {

    const [selectedCodes, setSelectedCodes] = useState<any>();
    const [isLoading, setIsloading] = useState(false);

    const {t} = useTranslation('', {keyPrefix: 'ImportUserFieldModal'});
    const handleClose = () => {
        props.closeModal(false)
    }
    const parseFile = (file: any) => {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results: any) => {
                const errors: string[] = [];
                const userNames: string[] = [];
                const fieldNames: string[] = [];
                const fieldValues: any[] = [];

                if (!results.data || results.data.length === 0) {
                    Toast.fire({
                        icon: 'warning',
                        title: t('fileNotCorrect')
                    });
                    setSelectedCodes(undefined);
                    return;
                }

                const rows = results.data;

                rows.forEach((row: any, index: number) => {
                    const rowIndex = index + 2; // account for header row

                    // Check for missing or empty fields
                    const userName = row?.userName?.trim();
                    const fieldName = row?.fieldName?.trim();
                    const value = row?.value?.toString().trim();

                    if (!userName) {
                        errors.push(`Row ${rowIndex}: 'userName' is required.`);
                    }

                    if (!fieldName) {
                        errors.push(`Row ${rowIndex}: 'fieldName' is required.`);
                    }

                    if (!value) {
                        errors.push(`Row ${rowIndex}: 'value' is required.`);
                    }

                    // Collect valid data only if all fields exist
                    if (userName && fieldName && value) {
                        fieldValues.push({
                            value,
                            fieldName,
                            memberUserName: userName
                        });

                        // Collect unique values
                        if (!userNames.includes(userName)) {
                            userNames.push(userName);
                        }
                        if (!fieldNames.includes(fieldName)) {
                            fieldNames.push(fieldName);
                        }
                    }
                });

                // If any errors were found, show them and stop
                if (errors.length > 0) {
                    Toast.fire({
                        icon: 'warning',
                        title: errors.join('\n'),
                        timer: 8000
                    });
                    setSelectedCodes(undefined);
                    return;
                }

                // Set the final parsed data matching backend format
                setSelectedCodes({
                    organization: props.id,
                    csvFileName: file.name,
                    userNames,
                    fieldNames,
                    fieldValues
                });
            }
        });
    };


    const csvChange = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            parseFile(e.target.files[0]);
        }
    };

    const addCodesSubmit = async () => {

        if (!selectedCodes) {
            Toast.fire({
                icon: 'warning',
                title: t('pleaseSelect')
            })
            return;
        }
        if (selectedCodes) {
            setIsloading(true);
            try {
                let data: any = {
                    "organization": props.id,
                    "csvFileName": selectedCodes.csvFileName,
                    "memberUserNames": selectedCodes.userNames,
                    "fieldNames": selectedCodes.fieldNames,
                    "fieldValues": selectedCodes.fieldValues
                }
                const result: any = await userFieldService.importOrgUserFields(data);
                setIsloading(false);
                if (result.statusCode == 201) {
                    const messgae = `File Imported Successfully 
                    Success: ${result.payload.processedFieldsCount}
                    Failed: ${result.payload.fieldsNotProcessedCount}`
                    Toast.fire({
                        icon: 'info',
                        title: messgae
                    })
                    props.closeModal(true)
                }
            } catch (error) {
                setIsloading(false);
                Toast.fire({
                    icon: 'warning',
                    title: t('importFailed')
                })
            }
        } else {
            Toast.fire({
                icon: 'warning',
                title: t('pleaseSelect')
            })
        }
    };

    return <Modal className="up-thememodal up-invitemembersmodal" show={true} onHide={handleClose}>
        <Modal.Header className="up-modalheader" closeButton>
            <Modal.Title>{t('importUserFieldCSV')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="up-modalbody">
            {isLoading && <FullPageLoader/>}
            <div className="up-modalcontentholder">
                <form className="up-formtheme up-forminvitememners">
                    <fieldset>
                        <div>
                            <CSVLink style={{textDecoration: 'underline', color: '#414141'}}
                                     filename={"sample_csv.csv"} data={csvData}>
                                <p style={{textDecoration: 'underline'}}><strong>{t('p16')} </strong></p>
                            </CSVLink>
                        </div>
                        {!selectedCodes && <div className="up-addmoreuploadcsv">
                            <div className="up-uploadcsv">
                                <input accept=".csv" onChange={csvChange} type="file" name="file"
                                       id="up-uploadcsvfile"/>
                                <label style={{fontWeight: "bold", fontSize: "16px"}}
                                       htmlFor="up-uploadcsvfile">{t('p18')}</label>
                            </div>
                        </div>}
                        {selectedCodes && <div className="up-addmoreuploadcsv">
                            <div className="up-uploadcsv">
                                <input accept=".csv" onChange={csvChange} type="file" name="file"
                                       id="up-uploadcsvfile"/>
                                <label style={{fontWeight: "bold", fontSize: "16px"}}
                                       htmlFor="up-uploadcsvfile">{t('selectedCSVFileName')}</label>
                                <label
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        marginLeft: 4
                                    }}>{' ' + selectedCodes.csvFileName}</label>
                            </div>
                        </div>}
                        <div className="up-formbuttonsarea">
                            <button type="button" onClick={() => addCodesSubmit()}
                                    className="up-btn">{t("import")}
                            </button>
                            <button type="button" className="up-btnclosmodal"
                                    onClick={handleClose}>{t('close')}</button>
                        </div>
                    </fieldset>
                </form>
            </div>
        </Modal.Body>
    </Modal>
}
